// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--light_text_color:#666}.logo-animated-path{stroke-dasharray:400;stroke-dashoffset:400;-webkit-animation:dash 1.25s ease-in-out infinite alternate;animation:dash 1.25s ease-in-out infinite alternate}@-webkit-keyframes dash{to{stroke-dashoffset:0}}@keyframes dash{to{stroke-dashoffset:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
